export default __webpack_public_path__ + "static/media/errorCheckFilled.0b2a660d.svg";